import { jsx as _jsx } from "react/jsx-runtime";
import clsx from 'clsx';
export function DrawerBody({ children, className }) {
    return (_jsx("div", { slot: "content", className: clsx('h-full border-t-small border-neutral-200', className), children: children }));
}
